import { useAuth } from '../../auth/AuthContext';
import { CreateVerificationPayload } from './verification.models';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { VerificationApi } from './verification.api';

export const VerificationQueries = {
  keys: {
    all: ['verifications'] as const,
    list: (page: number, size: number) =>
      [...VerificationQueries.keys.all, 'list', page, size] as const,
  },

  useGetVerifications: (page = 1, size = 1000000) => {
    const { isAuthenticated } = useAuth();

    return useQuery(
      VerificationQueries.keys.list(page, size),
      () => VerificationApi.getVerifications(page, size),
      {
        enabled: isAuthenticated,
        refetchOnWindowFocus: false,
      }
    );
  },
  useCreateVerification: () => {
    const queryClient = useQueryClient();

    return useMutation(
      (payload: CreateVerificationPayload) =>
        VerificationApi.createVerification(payload),
      {
        onSuccess: () => {
          queryClient.invalidateQueries(VerificationQueries.keys.all);
        },
      }
    );
  },

  useBulkUploadVerifications: () => {
    const queryClient = useQueryClient();

    return useMutation(VerificationApi.bulkUploadVerifications, {
      onSuccess: (data) => {
        console.log('Bulk upload completed successfully:', data);
        // Invalidate and refetch verifications list
        queryClient.invalidateQueries(VerificationQueries.keys.all);
      },
      onError: (error: Error) => {
        console.error('Failed to bulk upload verifications:', error);
      },
    });
  },
};
